import { Button, Modal, Spinner } from 'react-bootstrap';
import TextTruncate from 'react-text-truncate';
import DataDownload from '../DataDownload';
import DownloadStatus from '../DownloadStatus';
import PermissionsHelper from '../../util/PermissionsHelper';
import CLM from '../../images/CLMLogo.png';
import ITS from '../../images/treatmentTrackerIcon2.webp';
import SCIRP from '../../images/CWFRTF_logo_badge_clr.png';
import { useEffect, useState } from 'react';
import CKAN from '../../lib/CKAN';
import ListCardBasic from './ListCardBasic';
import { formatTitle } from '../../util/TitleHelper';

const ListCard = (props) => {
  const {
    dataset,
    inWorkspace: checkInWorkspace,
    addToWorkspace,
    removeFromWorkspace,
    user,
  } = props;
  const [loading, setLoading] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [downloadError, setDownloadError] = useState(null);
  const [versionDatasets, setVersionDatasets] = useState(null);
  const [displayHistory, setDisplayHistory] = useState(false);
  const inWorkspace = checkInWorkspace(dataset);

  const adminOnly = PermissionsHelper(user.roles, 'admin');
  const itemGis = props.getGisService(dataset);
  const isBoundary =
    itemGis && itemGis?.layer_name.search('boundary') !== -1 ? true : false;
  const isITS =
    itemGis && itemGis?.layer_name.search('ITS:') !== -1 ? true : false;
  // SCIRP datasets get the Task Force badge (icon only - not ITS behavior).
  const isSCIRP = dataset.extras?.some(
    (e) =>
      e.key === 'collection_name' &&
      e.value === 'Southern California Ignition Reduction Program'
  );
  const isOper = itemGis?.service_url.search('oper') !== -1 ? true : false;
  useEffect(() => {
    let historyIdsArray = [];
    const getHistory = async (id) => {
      const results = await CKAN.getHistoryById(id);
      const derivesFromData = results.filter(
        (data) => data.type == 'derives_from'
      );
      if (derivesFromData.length) {
        historyIdsArray.push(derivesFromData[0].object);
        getHistory(derivesFromData[0].object);
      } else {
        fetchData(historyIdsArray);
      }
    };
    const fetchData = async (historyIds) => {
      const historyList = await Promise.all(
        historyIds.map(async (name) => {
          const data = await CKAN.getSpecificDatasetByName(name).then(
            (response) => {
              return response[0];
            }
          );
          return data;
        })
      );
      setVersionDatasets(historyList);
    };

    if (isITS) getHistory(dataset.name);
  }, [dataset]);

  const handleView = () => {
    window.open(`/catalog/${dataset.name}`, '_blank');
    // props.setModalData(dataset);
    // props.setModalShow(true);
  };
  const handleDownload = async () => {
    setLoading(true);
    setDownloadError(null);
    try {
      await DataDownload(dataset, { onStatus: setDownloadStatus });
    } catch (error) {
      console.error(error);
      setDownloadError(error.message);
    } finally {
      setDownloadStatus(null);
      setLoading(false);
    }
  };

  const handleApisView = () => {
    props.setAPIsModalData(dataset);
    props.setAPIsModalShow(true);
  };

  const handleVersionView = () => {
    setDisplayHistory(true);
  };

  return (
    <div className="page_layout_1">
      {displayHistory ? (
        <Modal
          show={true}
          onHide={() => {
            setDisplayHistory(false);
          }}
          size="xl"
          aria-labelledby="version-history-modal-title"
          centered
        >
          <Modal.Header closeButton>
            <h4 id="version-history-modal-title">Version History</h4>
          </Modal.Header>
          <Modal.Body>
            {versionDatasets ? (
              <>
                {versionDatasets.map((data, index) => {
                  return (
                    <ListCardBasic
                      key={data.name + index}
                      dataset={data}
                      setModalData={props.setModalData}
                      setModalShow={props.setModalShow}
                      setModalImage={props.setModalImage}
                      setAPIsModalData={props.setAPIsModalData}
                      setAPIsModalShow={props.setAPIsModalShow}
                      addToWorkspace={props.addToWorkspace}
                      removeFromWorkspace={props.removeFromWorkspace}
                      inWorkspace={props.inWorkspace}
                      user={props.user}
                      getGisService={props.getGisService}
                    />
                  );
                })}
              </>
            ) : (
              <>No version history was found</>
            )}
          </Modal.Body>
        </Modal>
      ) : null}
      <div className="img_background" aria-hidden="true">
        {isITS ? (
          <img className="img_its" src={ITS} alt="Its logo" />
        ) : isSCIRP ? (
          <img className="img_scirp" src={SCIRP} alt="SCIRP logo" />
        ) : !isBoundary ? (
          <img className="img_clm" src={CLM} alt="Clm logo" />
        ) : (
          <img
            className="img_boundary"
            alt="boundary image"
            src={
              `${process.env.REACT_APP_API_URL}/Utility/wms_thumbnail?wms_url=` +
              itemGis.service_url +
              `&layer_name=` +
              itemGis.layer_name.split(':')[1] +
              `&width=200&height=200`
            }
          />
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          marginBottom: '1rem',
        }}
      >
        <p
          style={{
            fontSize: '16px',
            fontWeight: 'bolder',
            marginBottom: '0',
          }}
        >
          {formatTitle(dataset.title)}
        </p>
        {!isBoundary && (
          <p style={{ fontSize: '12px', marginBottom: '4px' }}>
            By {dataset.org_title}
          </p>
        )}
        <TextTruncate
          line={2}
          element="span"
          truncateText="…"
          text={dataset.notes}
          style={{ fontSize: '13px', marginBottom: '4px' }}
        />

        <div className="card_buttons" style={{ marginBottom: '2px' }}>
          <Button
            className="btn_primary"
            onClick={handleView}
            disabled={!itemGis}
          >
            View More
          </Button>

          {!isOper && (
            <Button
              style={{
                backgroundColor: inWorkspace ? '#664A00' : '#996B00',
                marginRight: '4px',
                border: 'none',
              }}
              onClick={() => {
                if (checkInWorkspace(dataset)) {
                  removeFromWorkspace(dataset);
                } else {
                  addToWorkspace(dataset);
                }
              }}
              disabled={!itemGis}
            >
              {inWorkspace ? 'Remove from  Map Viewer' : 'Add to  Map Viewer'}
            </Button>
          )}

          <Button
            style={{
              backgroundColor: '#3f7c85',
              marginRight: '4px',
              border: 'none',
            }}
            onClick={handleApisView}
            disabled={!itemGis}
          >
            APIs
          </Button>
          {/* <Button
            style={{
              backgroundColor: '#468373',
              marginRight: '4px',
              border: 'none',
            }}
          >
            Edit Metadata
          </Button> */}
          {isITS && (
            <Button
              style={{
                backgroundColor: '#4c633f',
                marginRight: '4px',
                border: 'none',
              }}
              onClick={handleVersionView}
            >
              Previous Versions
            </Button>
          )}
          <Button
            style={{
              backgroundColor: '#2c3e37',
              marginRight: '4px',
              border: 'none',
            }}
            onClick={handleDownload}
            disabled={loading || !itemGis}
          >
            {loading && (
              <>
                <Spinner animation="border" size="sm" aria-hidden="true" />{' '}
                <span className="visually-hidden">Downloading…</span>
              </>
            )}
            Download{isBoundary ? ' GeoJSON' : isITS ? ' GDB' : ' Zip'}
          </Button>
          {/* {adminOnly && (
            <Button
              style={{
                backgroundColor: 'black',
                marginRight: '4px',
                border: 'none',
              }}
              onClick={() => {
                props.setDeleteData();
              }}
            >
              Delete
            </Button>
          )} */}
        </div>
        <DownloadStatus status={downloadStatus} error={downloadError} />
      </div>
    </div>
  );
};
export default ListCard;
